import { FormFieldType } from '../typings';
import { DefaultFormFieldBuilder } from '.';

export abstract class BaseCompoundFormFieldBuilder<
  T,
> extends DefaultFormFieldBuilder<T> {
  protected abstract _type: FormFieldType;
  protected abstract _typeValue: FormFieldType;

  protected constructor() {
    super();
  }
}
